import Vue from "vue";
import Vuelidate from 'vuelidate';

import Nss from './components/index';

Vue.component("BackLink", Nss.Misc.BackLink);
Vue.component("Button", Nss.Misc.Button);
Vue.component("Checklist", Nss.Misc.Checklist);
Vue.component("Details", Nss.Misc.Details);
Vue.component("Panel", Nss.Misc.Panel);
Vue.component("PhaseBanner", Nss.Misc.PhaseBanner);
Vue.component("Rationale", Nss.Misc.Rationale);
Vue.component("WarningCallout", Nss.Misc.WarningCallout);
Vue.component("WarningCalloutAlt", Nss.Misc.WarningCalloutAlt);
Vue.component("InsetText", Nss.Misc.InsetText);
Vue.component("Wysiwyg", Nss.Misc.Wysiwyg);
Vue.component("Section", Nss.Misc.Section);
Vue.component("Form", Nss.Forms.Form);
Vue.component("DateOfBirth", Nss.Forms.DateOfBirth);
Vue.component("DateOfBirthInput", Nss.Forms.DateOfBirthInput);
Vue.component("IntroForm", Nss.Forms.IntroForm);
Vue.component("RadioList", Nss.Forms.RadioList);
Vue.component("Fieldset", Nss.Forms.Fieldset);
Vue.component("TextInput", Nss.Forms.TextInput);
Vue.component("Textarea", Nss.Forms.Textarea);
Vue.component("Dropdown", Nss.Forms.Dropdown);
Vue.component("RadioButton", Nss.Forms.RadioButton);
Vue.component("CheckboxList", Nss.Forms.CheckboxList);
Vue.component("CheckboxButton", Nss.Forms.CheckboxButton);
Vue.component("Submit", Nss.Forms.Submit);
Vue.component("Errors", Nss.Forms.Errors);

Vue.use(Vuelidate);

export default {};